// 现货杠杆相关数据store
import { axiosClient } from "~/common/js/axios";
import {
  insertSignToParams,
  isLoginedToken,
} from "~/common/js/utils";
import Cookies from "js-cookie";
import { getCommunalimitCountry } from "~/common/js/helper";
import { defineStore } from "pinia";
import { useIndexStore } from "./index";
import { useAccountStore } from "./account";
import { transLang } from '~/common/js/storeUtil';
export const useMarginStore = defineStore("margin", {
  state: () => ({
    // 交易对相关
    symbolLoading: false,
    symbolList: [], // 交易对
    symbolMap: {}, // 交易对字典
    // 币种相关
    coinLoading: false,
    coinList: [], // 币种
    coinMap: {}, // 币种字典
    marginAllowedCountry: [], // 杠杆允许的国家
    isMarginOpen: null, // 杠杆是否开通 false 没开通 true开通
  }),
  getters: {
    // 杠杆是否允许
    isMarginAllow(state) {
      // const kycLevel = rootState.account.kycLevel
      // const country = rootState.account.country
      // if (!isLoginedToken()) {
      //   return false
      // }
      // if (+kycLevel === 11) {
      //   // 内部用户
      //   return true
      // } else {
      //   // 看是否在开放地区
      //   if (state.marginAllowedCountry.includes(country)) {
      //     // 在开放国家列表中，允许
      //     return true
      //   } else {
      //     // 不在开放国家列表中，不允许
      //     return false
      //   }
      // }

      // 以上代码最好保留，为以后合规留下口子
      return true;
    },
  },
  actions: {
    SET_SYMBOL_LOADING(status) {
      this.symbolLoading = status;
    },
    // 杠杆资产交易对列表更新
    SET_SYMBOL_LIST(payload) {
      this.symbolList = payload;

      this.symbolMap = payload.reduce((map, item) => {
        // console.log('item', item)
        const coinList = [
          {
            iconUrl: item.coinUrl,
            coinName: item.coinFullName,
            coinShortName: item.coinName,
            coinType: item.coinId,
            priceType: 0,
          },
          {
            iconUrl: item.marketCoinUrl,
            coinName: item.marketCoinFullName,
            coinShortName: item.marketCoinName,
            coinType: item.marketCoinId,
            priceType: 1,
          },
        ];
        map[item.tradeMappingId] = {
          ...item,
          coinList: coinList,
          coinMap: coinList.reduce((map, coinItem) => {
            map[coinItem.coinType] = coinItem;
            return map;
          }, {}),
        };
        return map;
      }, {});
    },
    SET_COIN_LOADING(status) {
      this.coinLoading = status;
    },
    // 杠杆资产币种列表更新
    SET_COIN_LIST(payload) {
      this.coinList = payload;
      this.coinMap = payload.reduce((map, item) => {
        map[item.coinType] = item;
        return map;
      }, {});
    },
    // 设置杠杆开户状态
    SET_MARGIN_ISOPEN(isOpen) {
      this.isMarginOpen = isOpen;
    },
    SET_MARGIN_OPEN_COUNTRY(country) {
      this.marginAllowedCountry = country;
    },
    /**
     * getSymbolList 获取杠杆资产的交易对信息
     * @param state
     * @param commit
     * @param rootState
     * @returns {Promise<void>}
     */
    async getSymbolList(reset = false) {
      if (this.symbolLoading) return;

      // 已存在且不重置时，不重复请求
      if (!reset && this.symbolList.length > 0) return;

      this.SET_SYMBOL_LOADING(true);

      // const token = Cookies.get('accessToken')
      // const salt = Cookies.get('accessSalt')
      // const lang = rootState.locale

      // const params = {
      //   // local: transLang(lang),
      //   // timestamp: new Date().getTime(),
      // }

      const resData = await axiosClient({
        // @TODO 这里接口地址需要变 ，如变成 /find_leverage_symbol_list？
        url: "/gw-api/ds/find_leverage_symbol_list",
        method: "GET",
        // headers: {
        //   Authorization: token,
        // },
        // params,
      });

      if (resData && resData.success) {
        this.SET_SYMBOL_LIST(resData.data);
      }
      this.SET_SYMBOL_LOADING(false);
    },
    /**
     * getCoinList 获取钱包所有币种信息
     * @param state
     * @param commit
     * @param rootState
     * @returns {Promise<void>}
     */
    async getCoinList(reset = false) {
      if (!isLoginedToken()) {
        return;
      }

      if (this.coinLoading) return;

      // 已存在且不重置时，不重复请求
      if (!reset && this.coinList.length > 0) return;

      this.SET_COIN_LOADING(true);

      // const token = Cookies.get('accessToken')
      const salt = Cookies.get("accessSalt");

      const indexStore = useIndexStore();
      const lang = indexStore.locale;

      const params = {
        local: transLang(lang, indexStore),
        timestamp: new Date().getTime(),
      };

      insertSignToParams(params, params.timestamp, salt);

      const resData = await axiosClient({
        url: "/gw-api/asset-gateway/asset/coin",
        method: "get",
        // headers: {
        //   Authorization: token,
        // },
        params,
      }).finally(() => {
        this.SET_COIN_LOADING(false);
      });

      if (resData && resData.success) {
        this.SET_COIN_LIST(resData.data?.assetCoinList);
      }
    },
    // 获取用户白名单区域
    async getMarginAccountBlock() {
      if (!isLoginedToken()) {
        // 未登录，不走后面逻辑
        return;
      }

      const accountStore = useAccountStore();
      if (!accountStore.kycLevel) {
        accountStore.getUserSecInfo()
      }

      const marginAllowedCountry = await getCommunalimitCountry("lever_open");
      this.SET_MARGIN_OPEN_COUNTRY(marginAllowedCountry);
    },
    // 获取用户杠杆是否开通, 是否允许
    async getMarginAccountOpened() {
      return axiosClient({
        method: "GET",
        url: "/gw-api/user-center/user/ext/accountOpened",
      }).then((res) => {
        if (res?.success) {
          this.SET_MARGIN_ISOPEN(!!res.data);
        }
      });
    },
  },
});
